import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type SubscriberSortBy } from '../../domain/models/subscriber'

export class GetSubscribersQuery extends GetNetworkQuery {
  constructor(
    private readonly search: string | null,
    private readonly region: string[] | null,
    private readonly country: string[] | null,
    private readonly subscriptionSource: string[] | null,
    private readonly subscriptionPlan: string[] | null,
    private readonly subscriptionLevel: string[] | null,
    private readonly previousSubscriptionLevel: string[] | null,
    private readonly subscriptionStatuses: string[] | null,
    private readonly sortBy: SubscriberSortBy,
    private readonly sortOrder: 'asc' | 'desc',
    private readonly offset: number,
    private readonly limit: number,
    private readonly organization: string,
    private readonly fuzzy: boolean
  ) {
    super(ApiEndpoint.Subscribers)
  }

  public get queryParameters(): HttpParameters {
    const params: HttpParameters = {
      sort_by: this.sortBy,
      sort_order: this.sortOrder,
      offset: this.offset,
      limit: this.limit,
      organization: this.organization
    }

    if (this.search) {
      params.search = this.search
      if (this.fuzzy) params.fuzzy = true
    }

    if (this.region && this.region.length > 0) {
      params.region = this.region
    }

    if (this.country && this.country.length > 0) {
      params.country = this.country
    }

    if (this.subscriptionSource && this.subscriptionSource.length > 0) {
      params.subscription_source = this.subscriptionSource
    }

    if (this.subscriptionPlan && this.subscriptionPlan.length > 0) {
      params.subscription_plan = this.subscriptionPlan
    }

    if (this.subscriptionLevel && this.subscriptionLevel.length > 0) {
      params.subscription_level = this.subscriptionLevel
    }

    if (this.previousSubscriptionLevel && this.previousSubscriptionLevel.length > 0) {
      params.previous_subscription_level = this.previousSubscriptionLevel
    }

    if (this.subscriptionStatuses && this.subscriptionStatuses.length > 0) {
      params.subscription_status = this.subscriptionStatuses
    }

    return params
  }
}
